export default "__VITE_ASSET__afab1d3e__"